module.exports = __webpack_public_path__ + "static/media/check-icon.0aa99f8c.svg";